import {Button, Input, Textarea, Typography,} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {getProvinceCities} from "../../../services/city/city";
import {getProvinces} from "../../../services/province/province";
import Validator from "../../../helper/validator/Validator";
import {Toaster} from "../../../helper/Toaster";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {updateBackOfficeAgentRequestContactInfo} from "../../../services/back_office/agent";
import {checkAll} from "../../../helper/validator/Check";
import {toast} from "react-toastify";

export function BackOfficeAgentRequestContactInfo({
                                                    activeStep,
                                                    setActiveStep,
                                                    agentRequest,
                                                    setAgentRequest,
                                                    handleNext,
                                                    handlePrev,
                                                    isFirstStep,
                                                    isLastStep,
                                                    allowedStep,
                                                    setAllowedStep,
                                                    person_id
                                                  }) {

  const [id, setId] = useState(null);
  const [provinceId, setProvinceId] = useState(null)
  const [cityId, setCityId] = useState(null)
  const [homePhone, setHomePhone] = useState("")
  const [email, setEmail] = useState("")
  const [address, setAddress] = useState("")
  const [personId, setPersonId] = useState(null);

  useEffect(() => {
    setPersonId(person_id);
  }, [person_id]);

  useEffect(() => {
    setAgentRequest(agentRequest || null);
    setId((agentRequest && agentRequest.id) || null);
    setProvinceId((agentRequest && agentRequest.province_id) || "")
    setCityId((agentRequest && agentRequest.city_id) || "")
    setHomePhone((agentRequest && agentRequest.home_phone) || "")
    setEmail((agentRequest && agentRequest.email) || "")
    setAddress((agentRequest && agentRequest.address) || "")
  }, [agentRequest]);

  const save = async () => {
    const data = {
      id: id,
      province_id: parseInt(provinceId),
      city_id: parseInt(cityId),
      home_phone: homePhone,
      email: email,
      address: address,
      person_id: personId,
    };
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    }

    let result;

    result = await updateBackOfficeAgentRequestContactInfo(data);

    if (result.status === 200) {
      const {UserAgentRequest} = result.data;
      setAgentRequest(UserAgentRequest);
      if (allowedStep === 1) {
        setAllowedStep(2)
      }
      handleNext(2);
    }

  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">

          <div className="flex flex-col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("province")}
              defaultValue={provinceId}
              autoLoadService={getProvinces}
              onChange={setProvinceId}
            />
            <Validator state={provinceId} rules="required"/>
          </div>
          <div className="flex flex-col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("city")}
              defaultValue={cityId}
              refreshSignal={provinceId}
              autoLoadService={getProvinceCities}
              autoLoadServiceData={provinceId}
              onChange={setCityId}
            />
            <Validator state={cityId} rules="required"/>
          </div>


          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={homePhone}
                   label={Dict('home_phone')}
                   placeholder={Dict('home_phone')}
                   onChange={(e) => {
                     setHomePhone(e.target.value)
                   }}
            />
            <div className="flex flex-row">
              <Validator state={homePhone} rules="required"/>
              <Validator state={homePhone} rules="num"/>
            </div>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={email}
                   label={Dict('email')}
                   placeholder={Dict('email')}
                   onChange={(e) => {
                     setEmail(e.target.value)
                   }}
            />
            <div className="flex flex-row">
              <Validator state={email} rules="required"/>
              <Validator state={email} rules="email"/>
            </div>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Textarea className="flex flex-row"
                      variant="standard"
                      value={address}
                      label={Dict('address')}
                      onChange={(e) => {
                        setAddress(e.target.value)
                      }}
            />
            <div className="flex flex-row">
              <Validator state={address} rules="alphanumeric"/>
            </div>
          </div>


        </div>
        <div className="justify-between">
          <div className="mt-32 flex justify-between">
            <Button onClick={save} disabled={isLastStep}>
              مرحله بعدی
            </Button>
            <Button onClick={() => {
              handlePrev(0)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
      </>
    </ValidatorProvider>

  )
    ;
}